import script from "./videoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./videoDialog.vue?vue&type=script&setup=true&lang=js"

import "./videoDialog.vue?vue&type=style&index=0&id=3297893a&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3297893a"]])

export default __exports__